import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup, CircularProgress, Typography } from '@mui/material';
import ReportShell from '../components/ReportShell';
import PivotTable from '../components/PivotTable';
import { MeasureControls, useMeasure } from '../components/MeasureControls';
import YearBasisToggle from '../components/YearBasisToggle';
import useStats from '../useStats';
import { crossTabByYear, fmtMoney, fmtInt } from '../lib/pivot';

/**
 * Reusable "<dimension> × year" pivot. Measure (revenue / orders / units),
 * revenue basis (net / +postage / postage) and a Raw/% toggle. Used for Sales
 * by country, region and channel.
 */
export default function DimensionByYearReport({ title, dimension, rowLabel, rowLabels }) {
  const { stats, loading } = useStats();
  const measure = useMeasure('units');
  const [percent, setPercent] = useState(false);
  const [yearBasis, setYearBasis] = useState('calendar');

  const controls = (
    <>
      <MeasureControls {...measure} />
      <ToggleButtonGroup size="small" exclusive value={percent ? 'pct' : 'raw'} onChange={(_, v) => v && setPercent(v === 'pct')}>
        <ToggleButton value="raw">Raw</ToggleButton>
        <ToggleButton value="pct">%</ToggleButton>
      </ToggleButtonGroup>
      <YearBasisToggle value={yearBasis} onChange={setYearBasis} />
    </>
  );

  let body;
  if (loading || !stats) {
    body = <CircularProgress />;
  } else {
    const { rows, cols, value } = crossTabByYear(stats.monthly, dimension, measure.get, { rowLabels, basis: yearBasis });
    body = rows.length ? (
      <PivotTable
        rows={rows}
        cols={cols}
        value={value}
        percent={percent}
        rowLabel={rowLabel}
        format={measure.money ? fmtMoney : fmtInt}
      />
    ) : (
      <Typography variant="body2" color="text.secondary">
        No data yet — import orders and Rebuild stats.
      </Typography>
    );
  }

  return (
    <ReportShell title={title} controls={controls}>
      {body}
    </ReportShell>
  );
}
